<template>
    <div>
        <div class="topline">
            <h1>Min side <span>/</span> <span>Ordrer</span></h1>

            <div class="searching">
                <form>
                    <input type="text" v-model="query" name="q" placeholder="Søg efter ordre">
                    <button type="button">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="pageLoad" v-if="loading">
            <div class="spinner"></div>
        </div>

        <v-layout row wrap>
            <v-flex xs12 sm4 v-for="item in filteredOrders" :key="item.ordrenummer">
                <div class="produktEkstra fakturaList">
                    <ul>
                        <li>
                            <span class="fakturanummer">Ordre {{item.ordrenummer}}</span>
                        </li>
                        <li>
                            <span class="dato">{{item.ordreDato}}</span>
                        </li>
                        <li>
                            <span class="reference">{{item.eksterntBilagsNummer}}</span>
                        </li>
                        <li class="goRight">
                            <!--<a class="tt" href="https://www.consignorportal.com/" target="_blank">Track & Trace<i class="fa fa-truck" aria-hidden="true"></i></a>-->
                            <router-link class="seIndhold" :to="'/profile/orders/' + item.ordrenummer">Se ordren <i class="fa fa-info" aria-hidden="true"></i></router-link>
                        </li>
                    </ul>
                </div>
            </v-flex>
        </v-layout>


    </div>
</template>

<script>
    export default {
        data: () => ({
            orders: [],
            loading: true,
            query: null
        }),
        components: {},
        computed: {
            filteredOrders() {
                if (this.query == null || this.query == '') {
                    return this.orders;
                }

                return this.orders.filter(x =>
                    (x.ordrenummer && x.ordrenummer.toLowerCase().includes(this.query.toLowerCase())) ||
                    (x.eksterntBilagsNummer && x.eksterntBilagsNummer.toLowerCase().includes(this.query.toLowerCase())) ||
                    (x.ordreDato && x.ordreDato.toLowerCase().includes(this.query.toLowerCase()))
                );
            }
        },
        methods: {

        },
        created() {
            this.$http.get("/api/profile/orders").then(x => {
                this.orders = x.data;
                this.loading = false;
            });
        },
        mounted() {

        }
    }
</script>
